import { HttpParams } from '@angular/common/http';
import { toHTTPParam } from '../../../core';

import { Filter } from '../../../models';

export class NotaFilter implements Filter {
    isFilterDirty: boolean;

    dataInicial: Date;
    dataFinal: Date;
    idsUsuariosCreated: number[] = [];
    texto: string;
    idsLeads: number[] = [];
    idsClientes: number[] = [];
    idsNegocios: number[] = [];
    idsTitulosReceber: number[] = [];
    idsReferenciaLeads: number[] = [];
    idsReferenciaClientes: number[] = [];
    idsReferenciaNegocios: number[] = [];
    idsReferenciaTitulosReceber: number[] = [];

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Data Inicial
        if (this.dataInicial) {
            params = params.append('dataInicial', toHTTPParam(this.dataInicial));
        }
        // Data Final
        if (this.dataFinal) {
            params = params.append('dataFinal', toHTTPParam(this.dataFinal));
        }

        // Usuários Created
        this.idsUsuariosCreated?.forEach(idUsuarioCreated => {
            params = params.append('idUsuarioCreated', idUsuarioCreated.toString());
        });

        // Texto
        if (this.texto) {
            params = params.append('texto', this.texto);
        }

        // Leads
        this.idsLeads?.forEach(idLead => {
            params = params.append('idLead', idLead.toString());
        });

        // Clientes
        this.idsClientes?.forEach(idCliente => {
            params = params.append('idCliente', idCliente.toString());
        });

        // Negócios
        this.idsNegocios?.forEach(idNegocio => {
            params = params.append('idNegocio', idNegocio.toString());
        });

        // Títulos a Receber
        this.idsTitulosReceber?.forEach(idTituloReceber => {
            params = params.append('idTituloReceber', idTituloReceber.toString());
        });

         /** Referências */
        // Leads
        this.idsReferenciaLeads?.forEach(idReferenciaLead => {
            params = params.append('idReferenciaLead', idReferenciaLead.toString());
        });

        // Clientes
        this.idsReferenciaClientes?.forEach(idReferenciaCliente => {
            params = params.append('idReferenciaCliente', idReferenciaCliente.toString());
        });

        // Negócios
        this.idsReferenciaNegocios?.forEach(idReferenciaNegocio => {
            params = params.append('idReferenciaNegocio', idReferenciaNegocio.toString());
        });

        // Títulos a Receber
        this.idsReferenciaTitulosReceber?.forEach(idReferenciaTituloReceber => {
            params = params.append('idReferenciaTituloReceber', idReferenciaTituloReceber.toString());
        });

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.dataInicial = null;
        this.dataFinal = null;
        this.idsUsuariosCreated = [];
        this.texto = null;
        this.idsLeads = [];
        this.idsClientes = [];
        this.idsNegocios = [];
        this.idsTitulosReceber = [];
        this.idsReferenciaLeads = [];
        this.idsReferenciaClientes = [];
        this.idsReferenciaNegocios = [];
        this.idsReferenciaTitulosReceber = [];
    }
}
